/* eslint-disable react/prop-types */
import React, { useContext, useState } from 'react';
import { FiltersCard, FiltersRow, SearchWrapper } from '~/styles/tabela1';
import { Button, FlexboxGrid } from 'rsuite';
import { DarkModeContext } from '../../common/contexts/darkMode';

function AdvancedFilters({
  header,
  activeFilters,
  children,
}) {
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  const { toggleMode } = useContext(DarkModeContext)
  return (
    <FiltersCard darkMode={toggleMode}>

      <FiltersRow
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '16px',
          padding: '24px'
        }}>

        <SearchWrapper>
          {header}
        </SearchWrapper>
        {(activeFilters !== undefined)
          ? (
            <Button
              appearance="ghost"
              onClick={() =>
                setShowAdvancedFilters((v) => !v)
              }
            >
              {showAdvancedFilters
                ? 'Ocultar filtros'
                : 'Filtros avançados'}
            </Button>
          )
          : null}
        {/* <Button
          appearance="ghost"
          onClick={() =>
            setShowAdvancedFilters((v) => !v)
          }
        >
          {showAdvancedFilters
            ? 'Ocultar filtros'
            : 'Filtros avançados'}
        </Button> */}

      </FiltersRow>
      {showAdvancedFilters ? (
        <div
          style={{
            padding: '24px',
            borderTop: '1px solid #E5E7EB'
          }}
        >
          <FlexboxGrid style={{ gap: '12px' }}>
            {children}

          </FlexboxGrid>
        </div>
      ) : null}

      {(activeFilters !== undefined && activeFilters.length > 0) ? (
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '10px',
            padding: '20px 24px',
            borderTop: '1px solid #E5E7EB',
          }}
        >
          {activeFilters.map((filtro) => (
            <div
              key={filtro.key}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '6px 12px',
                background: '#F3F4F6',
                borderRadius: '999px',
                fontSize: '13px',
                color: '#374151',
              }}
            >
              <span>{filtro.label}</span>

              <span
                role="button"
                tabIndex={0}
                style={{
                  cursor: 'pointer',
                  fontWeight: 700,
                }}
                // onClick={() => onRemoveFilter(filtro.key)}
                onClick={filtro.clear}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    // onRemoveFilter(filtro.key);
                    e.preventDefault();
                    filtro.clear();
                  }
                }}
              >
                ×
              </span>
            </div>
          ))}
          <Button
            appearance="link"
            // appearance="subtle"
            // size="sm"
            // onClick={conClearAllFilters}
            onClick={() => activeFilters.forEach((filtro) => filtro.clear())}
            style={{
              padding: '6px 12px',
              background: '#F3F4F6',
              borderRadius: '999px',
              fontSize: '13px',
              color: '#374151',
            }}
          >
            Limpar {activeFilters.length} filtro(s) ativos
          </Button>
        </div>
      ) : null}

    </FiltersCard>
  );
}

export default AdvancedFilters;